export enum CasesGamePhases {
    INITIALIZE = 'initialize',
    REQUEST = 'request',
    RAFFLE = 'raffle',
    VICTORY = 'victory',
  }